import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function MouthTongueText() {

    
    return (

     <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Protect Your " 
            headline_grey = "Tongue"
            headline_p2 = "from inflammation and bad bacteria"

            text1 = "Protecting your tongue involves consistent oral hygiene, dietary habits, and regular oral care."
            text2 = "Your mouth is also home to your oral microbiome — billions of bacteria and fungi. Some cause inflammation, some lead to bad breath, while others keep us healthy."
            text3 = "We test your oral microbiome, identifying the bacteria causing problems and help you get rid of them."

            />
    }/>
            
  )
}